import React from 'react';

const Alert = ({ message, onDismiss }) => {
  return (
    <div className="updated notice is-dismissible">
      <p>{message}</p>
      <button type="button" className="notice-dismiss" onClick={onDismiss}>
        <span className="screen-reader-text">Dismiss this notice.</span>
      </button>
    </div>
  );
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/blocks/alert.jsx